import type { NavigateFunction } from "react-router-dom";
import type { User } from "@safers/api";
import { landingPath } from "@/lib/lastVisit";
import { HOME_PATH } from "@/routes/paths";

const ADMIN_HOME = "/admin/";

function isSafe(url: string | null): url is string {
  return !!url && url.startsWith("/") && !url.startsWith("//");
}

function isAdminUrl(url: string): boolean {
  return url === "/admin" || url.startsWith("/admin/");
}

export interface AfterLogin {
  user: User;
  returnUrl: string | null;
  navigate: NavigateFunction;
}

export function goAfterLogin({ user, returnUrl, navigate }: AfterLogin): void {
  const isAdmin = user.authority === "ADMIN";
  const wanted = isSafe(returnUrl) ? returnUrl : null;

  const target =
    wanted && (isAdmin || !isAdminUrl(wanted))
      ? wanted
      : isAdmin
        ? ADMIN_HOME
        : (landingPath(user) ?? HOME_PATH);

  if (isAdminUrl(target)) {
    window.location.assign(target);
    return;
  }
  navigate(target, { replace: true });
}
